import React from 'react';
import { Filter, X } from 'lucide-react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';

const EmployeeFilters = ({ filters, onFiltersChange, departments }) => {
  const handleFilterChange = (key, value) => {
    onFiltersChange(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const clearFilters = () => {
    onFiltersChange({
      department: '',
      location: '',
      status: '',
      employmentType: ''
    });
  };

  const hasActiveFilters = Object.values(filters)?.some(value => value);

  const statusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'active', label: 'Active' },
    { value: 'inactive', label: 'Inactive' },
    { value: 'on_leave', label: 'On Leave' }
  ];

  const employmentTypeOptions = [
    { value: '', label: 'All Types' },
    { value: 'ft', label: 'Full-time' },
    { value: 'pt', label: 'Part-time' },
    { value: 'contract', label: 'Contract' }
  ];

  const locationOptions = [
    { value: '', label: 'All Locations' },
    { value: 'Remote', label: 'Remote' },
    { value: 'New York', label: 'New York' },
    { value: 'San Francisco', label: 'San Francisco' },
    { value: 'London', label: 'London' },
    { value: 'Toronto', label: 'Toronto' }
  ];

  const departmentOptions = [
    { value: '', label: 'All Departments' },
    ...(departments?.map(dept => ({
      value: dept?.id,
      label: dept?.name
    })) || [])
  ];

  return (
    <div className="flex items-center space-x-4">
      <div className="flex items-center space-x-2">
        <Filter className="h-4 w-4 text-gray-500" />
        <span className="text-sm font-medium text-gray-700">Filters:</span>
      </div>
      <Select
        value={filters?.department}
        onChange={(value) => handleFilterChange('department', value)}
        options={departmentOptions}
        placeholder="Department"
        className="min-w-[140px]"
      />
      <Select
        value={filters?.location}
        onChange={(value) => handleFilterChange('location', value)}
        options={locationOptions}
        placeholder="Location"
        className="min-w-[120px]"
      />
      <Select
        value={filters?.status}
        onChange={(value) => handleFilterChange('status', value)}
        options={statusOptions}
        placeholder="Status"
        className="min-w-[110px]"
      />
      <Select
        value={filters?.employmentType}
        onChange={(value) => handleFilterChange('employmentType', value)}
        options={employmentTypeOptions}
        placeholder="Employment"
        className="min-w-[130px]"
      />
      {hasActiveFilters && (
        <Button
          variant="ghost"
          size="sm"
          onClick={clearFilters}
          className="text-gray-500 hover:text-gray-700"
        >
          <X className="h-4 w-4 mr-1" />
          Clear
        </Button>
      )}
    </div>
  );
};

export default EmployeeFilters;